import {
    createBrowserRouter
} from "react-router-dom";
import React from "react";
import {Login} from "./register/Login";
import {Register} from "./register/Register";
import Retrieve from "./retrieve/Retrieve";
import RetrieveValidate from "./retrieve/RetrieveValidate";
import EmailChangeValidator from "./email/EmailChangeValidator";
import EmailValidator from "./email/EmailValidator";
import WorkerValidator from "./worker/WorkerValidator";
import AclValidator from "./acl/AclValidator";
import { RootErrorElement } from "./RootErrorElement";
import { SocialModeSync } from "./social-auth/social-mode-sync";

export const routers = createBrowserRouter([
  {
    element: <SocialModeSync />,
    children: [
      {
        path: "/",
        element: <Login />,
        errorElement: <RootErrorElement />,
      },
      {
        path: "/login",
        element: <Login />,
        errorElement: <RootErrorElement />,
      },
      {
        path: "/register",
        element: <Register />,
        errorElement: <RootErrorElement />,
      },
      {
        path: "/retrieve",
        element: <Retrieve />,
      },
      {
        path: "/retrieve/validate",
        element: <RetrieveValidate />,
      },
      {
        path: "/email/change/validate",
        element: <EmailChangeValidator />,
      },
      {
        path: "/email/validate",
        element: <EmailValidator />,
      },
      {
        path: "/social/email/validate",
        element: <EmailValidator redirectTarget="/login?social=true" />,
      },
      {
        path: "*",
        element: <>Página no encontrada</>
      },
      {
        path: "/worker/validate",
        element: <WorkerValidator />,
      },
      {
        path: "/acl/validate",
        element: <AclValidator />,
      },
    ],
  },
]);
